import ROUTES from '../../enums/routes';
import ACL from '../../enums/aclGlobalRules';

// eslint-disable-next-line no-unused-vars
export default function getAdminNavigation(store) {
  return [
    {
      icon: 'dashboard',
      title: 'Dashboard',
      route: ROUTES.DASHBOARD,
    },
    {
      icon: 'domain',
      title: 'Clients',
      route: ROUTES.CLIENTS,
    },
    {
      icon: 'account_box',
      title: 'Admins',
      route: ROUTES.ADMINS,
    },
    {
      icon: 'local_hospital',
      title: 'Hospitals',
      route: ROUTES.HOSPITALS,
    },
    {
      icon: 'description',
      title: 'Templates',
      route: ROUTES.TEMPLATES,
    },
    {
      icon: 'picture_as_pdf',
      title: 'Reference Materials',
      route: ROUTES.MATERIALS,
    },
    {
      icon: 'mdi-receipt-outline',
      title: 'Invoicing',
      route: ROUTES.INVOICES,
    },
    {
      icon: 'build',
      title: 'Utilities',
      route: ROUTES.UTILITIES,
      divided: true,
      items: [
        {
          title: 'Reports/Incidents',
          icon: 'content_paste',
          items: [
            {
              icon: 'compare',
              title: 'Duplicate Incidents',
              route: ROUTES.DUPLICATE_INCIDENTS,
              description:
                  'Allows to resolve issue when incidents have same IncidentNumber.',
            },
            {
              icon: 'mdi-clipboard-search-outline',
              title: 'Incident System Search',
              route: ROUTES.INCIDENT_SYSTEM_SEARCH,
              description:
                  'Search incidents by entire system',
            },
          ],
        },
        {
          title: 'DHS/Billing',
          icon: 'mdi-bank-transfer',
          items: [
            {
              icon: 'folder_shared',
              title: 'Long Beach Billing',
              route: ROUTES.LONG_BEACH_BILLING,
              description: 'Billing data of Long Beach Client.',
            },
            {
              icon: 'import_export',
              title: 'Billing Export',
              route: ROUTES.UTILITIES_EXPORT,
              description: 'Manual management of Billing export.',
            },
            {
              icon: 'import_export',
              title: 'NEMSIS/DHS Export',
              route: ROUTES.DHS_EXPORT_UTILITY,
              description: 'Management of NEMSIS to DHS export.',
            },
          ],
        },
        {
          title: 'CAD',
          icon: 'mdi-car-emergency',
          items: [
            {
              icon: 'notification_important',
              title: 'CAD Monitoring',
              route: ROUTES.CAD_MONITORING,
              description: 'Status of CAD service.',
              isAvailable() {
                return store.getters.ability.can('showCadMonitoring', 'navigation');
              },
            },
            {
              icon: 'horizontal_split',
              title: 'Recent CAD Data',
              route: ROUTES.LAST_IMPORTED_INCIDENTS,
              description: 'Review RAW data received from CAD service.',
            },
          ],
        },
        {
          title: '3rd Party Exports',
          icon: 'mdi-export',
          items: [
            {
              icon: 'import_export',
              title: 'OD MAP Exports',
              route: ROUTES.OD_MAP_EXPORTS,
              description: 'Export log of drugs suspected incidents.',
              isAvailable() {
                return store.state.siteInfo.odMapExportsAllowed;
              },
            },
            {
              icon: 'import_export',
              title: 'HDE Exports',
              route: ROUTES.HDE_EXPORTS,
              description: 'Export log of HDE export incidents.',
            },
          ],
        },
        {
          title: 'iOS',
          icon: 'mdi-apple',
          items: [
            {
              icon: 'device_unknown',
              title: 'First Run Devices',
              route: ROUTES.FIRST_RUN_DEVICES,
              description: 'List of new devices registration requests.',
            },
            {
              icon: 'tablet_mac',
              title: 'API Interactions Log',
              route: ROUTES.API_AUDIT,
              description:
                  "Review log of interactions between backend and it's clients: Mobile App, Web Sites.",
            },
            {
              icon: 'notifications',
              title: 'Push Notifications',
              route: ROUTES.PUSH_NOTIFICATIONS,
              description: 'Manage Push Notifications service.',
            },
          ],
        },
        {
          title: 'Miscellaneous',
          icon: 'mdi-tools',
          items: [
            {
              icon: 'settings',
              title: 'Medication Settings',
              route: ROUTES.MEDICATION_SETTINGS,
              description: 'Manage Medication Settings.',
            },
            {
              icon: 'rule',
              title: 'Schematrons',
              route: ROUTES.SCHEMATRONS,
              description:
                'Upload and publish NEMSIS Schematron rulesets, and choose which clients validate against them.',
            },
            {
              icon: 'flag',
              title: 'Flagged Users',
              route: ROUTES.FLAGGED_USERS,
              description: 'Review list of Flagged Users / Incidents.',
            },
            {
              icon: 'notes',
              title: 'Release Notes',
              route: ROUTES.RELEASE_NOTES,
              description:
                  'Provide information on the features and improvements in each release: iOS App, Template, Backend',
            },
            {
              icon: 'error',
              title: 'Errors Utility',
              route: ROUTES.ERRORS_UTILITY,
              description: 'List of new devices registration requests.',
            },
            {
              icon: 'bug_report',
              title: 'Client Bug Reports',
              description: 'Forwards to bugtracker for clients.',
              link: 'https://digitalems.atlassian.net/projects/MC/queues/custom/1',
              rule: ACL.SUPER_ADMIN,
            },
            {
              icon: 'print',
              title: 'Faxes',
              route: ROUTES.FAXES,
              description: 'Faxes.',
            },
          ],
        },
      ],
    },
  ];
}
